import { useLocationQuery } from '../../../common/routing/useLocationQuery';

export const useIsEmbeddedLocation = () => {
    const query = useLocationQuery();
    return query.get('embedded') === '';
};
